export const loadScript = (src: string) => new Promise((resolve, reject) => {
  const script = Object.assign(
    document.createElement('script'),
    {
      src,
      onreadystatechange: resolve,
      onload: resolve,
      onerror: reject,
    },
  )

  document.head.appendChild(script)
})

export const createInput = (config: unknown = {}, container = document.body): void => {
  const $input = Object.assign(document.createElement('input'), { hidden: true }, config)

  container.appendChild($input)
}

export const log = () => { /** */ }
